export default "__VITE_PUBLIC_ASSET__03c8796f__"